<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <!-- <div class="tagView">
                <div class="title_aside"></div>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>{{
                        $route.meta.title
                    }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div> -->
            <div class="tableBox">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="已支付" name="first">
                        <div class="searchBar">
                            <el-form
                                :model="searchParam1"
                                status-icon
                                ref="searchData1"
                                label-position="left"
                                label-width="90px"
                                :inline="true"
                            >
                                <el-form-item label="">
                                    <el-date-picker
                                        v-model="dataVal1"
                                        @change="datetime"
                                        type="datetimerange"
                                        align="right"
                                        start-placeholder="支付完成开始时间"
                                        end-placeholder="支付完成结束时间"
                                        format="yyyy-MM-dd"
                                        value-format="timestamp"
                                        :default-time="['00:00:00', '23:59:59']"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-input
                                        type="text"
                                        v-model="searchParam1.orderId"
                                        autocomplete="off"
                                        placeholder="请输入订单号"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-button
                                        type="primary"
                                        @click="selectTable('first')"
                                        >查询</el-button
                                    >
                                    <el-button
                                        type="info"
                                        @click="
                                            (dataVal1='',searchParam1 = {page: 1,size: 10,status:1},pageSizeNum1=10), selectTable('first')
                                        "
                                        >重置</el-button
                                    >
                                    <el-button
                                        type="primary"
                                        @click="exportDialog=true"
                                        >导出历史订单</el-button
                                    >
                                </el-form-item>
                            </el-form>
                        </div>
                        <ExTable
                            ref="table1"
                            :table-list="tableData1"
                            :header="header1"
                            :isIndex="false"
                            height="300"
                            :total="total1"
                            :tableId="1"
                            :activeIndex ="searchParam1.page"
                            :pageSizeNum="pageSizeNum1"
                            @clickPage="clickPage"
                            @clickSize="clickSize"
                        >
                            <el-table-column slot="operate" label="操作" align="center" width="120" fixed="right">
                                <!-- <template>
                                    <el-tooltip class="item" effect="dark" 
                                    content="再次购买" placement="top">
                                        <i class="el-icon-ali-goumai icon-btn" @click="goBuy"></i>
                                    </el-tooltip>
                                </template> -->
                                <div class="btn-group">
                                    <p class="btn" @click="goBuy">再次购买</p>
                                </div>
                            </el-table-column>
                        </ExTable>
                    </el-tab-pane>
                    <el-tab-pane label="待支付" name="second">
                        <div class="searchBar">
                            <el-form
                                status-icon
                                ref="searchData2"
                                label-position="left"
                                label-width="90px"
                                :inline="true"
                            >
                                <el-form-item label="">
                                    <el-date-picker
                                        v-model="dataVal2"
                                        type="datetimerange"
                                        @change="datetime"
                                        align="right"
                                        start-placeholder="订单创建开始日期"
                                        end-placeholder="订单创建结束日期"
                                        format="yyyy-MM-dd"
                                        value-format="timestamp"
                                        :default-time="['00:00:00', '23:59:59']"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-input
                                        type="text"
                                        v-model="searchParam2.orderId"
                                        autocomplete="off"
                                        placeholder="请输入订单号"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-button
                                        type="primary"
                                        @click="selectTable('second')"
                                        >查询</el-button
                                    >
                                    <el-button
                                        type="info"
                                        @click="
                                            (dataVal2='',searchParam2 = {page: 1,size: 10,status:0},pageSizeNum2=10), selectTable('second')
                                        "
                                        >重置</el-button
                                    >
                                </el-form-item>
                            </el-form>
                        </div>
                        <p style="color:red;font-size:14px;margin-bottom:20px">*待支付订单24小时内有效，请尽快付款</p>
                        <ExTable
                            ref="table2"
                            :table-list="tableData2"
                            :isIndex="false"
                            :header="header2"
                            height="300"
                            :total="total2"
                            :tableId="2"
                            :activeIndex ="searchParam2.page"
                            :pageSizeNum="pageSizeNum2"
                            @clickPage="clickPage"
                            @clickSize="clickSize"
                        >
                            <el-table-column slot="operate" label="操作" align="center" width="180" fixed="right">
                                <template slot-scope="scope">
                                    <!-- <el-tooltip class="item" effect="dark" content="继续支付" placement="top">
                                        <i class="el-icon-ali-jine icon-btn" @click="goPayOredr(scope.row)"></i>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" content="取消订单" placement="top">
                                        <i class="el-icon-ali-quxiaodingdan icon-btn" @click="cancelOrder(scope.row)"></i>
                                    </el-tooltip> -->
                                    <div class="btn-group">
                                        <p class="btn" @click="goPayOredr(scope.row)">继续支付</p>
                                        <p class="btn" @click="cancelOrder(scope.row)">取消订单</p>
                                    </div>
                                </template>
                            </el-table-column>
                        </ExTable>
                    </el-tab-pane>
                    <el-tab-pane label="已取消" name="third">
                        <div class="searchBar">
                            <el-form
                                :model="searchParam3"
                                status-icon
                                ref="searchData3"
                                label-position="left"
                                label-width="90px"
                                :inline="true"
                            >
                                <el-form-item label="">
                                    <el-date-picker
                                        v-model="dataVal3"
                                        type="datetimerange"
                                        align="right"
                                        @change="datetime"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        format="yyyy-MM-dd"
                                        value-format="timestamp"
                                        :default-time="['00:00:00', '23:59:59']"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-input
                                        type="text"
                                        v-model="searchParam3.orderId"
                                        autocomplete="off"
                                        placeholder="请输入订单号"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-button
                                        type="primary"
                                        @click="selectTable('third')"
                                        >查询</el-button
                                    >
                                    <el-button
                                        type="info"
                                        @click="
                                            (dataVal3='',searchParam3 = {page: 1,size: 10,status:2},pageSizeNum3=10), selectTable('third')
                                        "
                                        >重置</el-button
                                    >
                                </el-form-item>
                            </el-form>
                        </div>
                        <ExTable
                            ref="table3"
                            :table-list="tableData3"
                            :isIndex="false"
                            :header="header3"
                            height="300"
                            :total="total3"
                            :tableId="3"
                            :activeIndex ="searchParam3.page"
                            :pageSizeNum="pageSizeNum3"
                            @clickPage="clickPage"
                            @clickSize="clickSize"
                        />
                    </el-tab-pane>
                    <el-tab-pane v-if="isShow" label="已退款" name="four">
                        <div class="searchBar">
                            <el-form
                                :model="searchParam4"
                                status-icon
                                ref="searchData4"
                                label-position="left"
                                label-width="90px"
                                :inline="true"
                            >
                                <el-form-item label="">
                                    <el-date-picker
                                        v-model="dataVal4"
                                        type="datetimerange"
                                        align="right"
                                        @change="datetime"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        format="yyyy-MM-dd"
                                        value-format="timestamp"
                                        :default-time="['00:00:00', '23:59:59']"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-input
                                        type="text"
                                        v-model="searchParam4.orderId"
                                        autocomplete="off"
                                        placeholder="请输入订单号"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-button
                                        type="primary"
                                        @click="selectTable('four')"
                                        >查询</el-button
                                    >
                                    <el-button
                                        type="info"
                                        @click="
                                            (dataVal4='',searchParam4 = {page: 1,size: 10,status:3},pageSizeNum4=10), selectTable('four')
                                        "
                                        >重置</el-button
                                    >
                                </el-form-item>
                            </el-form>
                        </div>
                        <ExTable
                            ref="table4"
                            :table-list="tableData4"
                            :isIndex="false"
                            :header="header4"
                            height="300"
                            :total="total4"
                            :tableId="4"
                            :activeIndex ="searchParam4.page"
                            :pageSizeNum="pageSizeNum4"
                            @clickPage="clickPage"
                            @clickSize="clickSize"
                        />
                    </el-tab-pane>
                    <el-tab-pane v-if="isShow2" label="已转入" name="five">
                        <div class="searchBar">
                            <el-form
                                :model="searchParam5"
                                status-icon
                                ref="searchData5"
                                label-position="left"
                                label-width="90px"
                                :inline="true"
                            >
                                <el-form-item label="">
                                    <el-date-picker
                                        v-model="dataVal5"
                                        type="datetimerange"
                                        align="right"
                                        @change="datetime"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        format="yyyy-MM-dd"
                                        value-format="timestamp"
                                        :default-time="['00:00:00', '23:59:59']"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-input
                                        type="text"
                                        v-model="searchParam5.orderId"
                                        autocomplete="off"
                                        placeholder="请输入订单号"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-button
                                        type="primary"
                                        @click="selectTable('five')"
                                        >查询</el-button
                                    >
                                    <el-button
                                        type="info"
                                        @click="
                                            (dataVal5='',searchParam5 = {page: 1,size: 10,payType:8},pageSizeNum5=10), selectTable('five')
                                        "
                                        >重置</el-button
                                    >
                                </el-form-item>
                            </el-form>
                        </div>
                        <ExTable
                            ref="table5"
                            :table-list="tableData5"
                            :isIndex="false"
                            :header="header5"
                            height="300"
                            :total="total5"
                            :tableId="5"
                            :activeIndex ="searchParam5.page"
                            :pageSizeNum="pageSizeNum5"
                            @clickPage="clickPage"
                            @clickSize="clickSize"
                        />
                    </el-tab-pane>
                    <el-tab-pane v-if="isShow3" label="预充值" name="six">
                        <div class="searchBar">
                            <el-form
                                :model="searchParam6"
                                status-icon
                                ref="searchData6"
                                label-position="left"
                                label-width="90px"
                                :inline="true"
                            >
                                <el-form-item label="">
                                    <el-date-picker
                                        v-model="dataVal6"
                                        type="datetimerange"
                                        align="right"
                                        @change="datetime"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        format="yyyy-MM-dd"
                                        value-format="timestamp"
                                        :default-time="['00:00:00', '23:59:59']"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-input
                                        type="text"
                                        v-model="searchParam6.orderId"
                                        autocomplete="off"
                                        placeholder="请输入订单号"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-button
                                        type="primary"
                                        @click="selectTable('six')"
                                        >查询</el-button
                                    >
                                    <el-button
                                        type="info"
                                        @click="
                                            (dataVal6='',searchParam6 = {page: 1,size: 10,payType:6},pageSizeNum6=10), selectTable('six')
                                        "
                                        >重置</el-button
                                    >
                                </el-form-item>
                            </el-form>
                        </div>
                        <ExTable
                            ref="table6"
                            :table-list="tableData6"
                            :isIndex="false"
                            :header="header6"
                            height="300"
                            :total="total6"
                            :tableId="5"
                            :activeIndex ="searchParam6.page"
                            :pageSizeNum="pageSizeNum6"
                            @clickPage="clickPage"
                            @clickSize="clickSize"
                        />
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <el-dialog
            title="导出历史订单"
            :visible.sync="exportDialog"
            width="612px"
            class="exportDialog"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            center
            @close="closeDia"
            >
            <p>注：当前支持2021.11.13之前在权利卫士，证据平台及知识产权平台的历史订单，由于历史数据比较庞大，默认每人仅可支持导出3次，提交后，系统会在24小时内发送至您下方的邮箱，请注意查收！下载后请妥善保管。</p>
            <el-form :model="exportForm" status-icon :rules="rules" ref="exportForm" label-width="100px" class="exportForm">
                <el-form-item label="请输入邮箱" prop="email">
                    <el-input type="text" v-model="exportForm.email" autocomplete="off" placeholder="请输入邮箱"></el-input>
                </el-form-item>
                <el-form-item label="邮箱验证码" prop="yzm" class="yzm-item">
                    <el-input type="text" v-model="exportForm.yzm" autocomplete="off" placeholder="请输入邮箱验证码"></el-input>
                    <span class="getyzm" :disabled="disabled" @click="getVerificationCode">{{yzmtext}}</span>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDia">取 消</el-button>
                <el-button type="primary" @click="submitDialogForm('exportForm')">确 定</el-button>
            </span>
        </el-dialog>
        <div id="captcha-element"></div>
    </el-row>
</template>

<script>
import ExTable from "@com/ExTable";
import {orderData,orderToCancel,userOrderRefund,userOrderInflow,userOrderPreRecharge} from "@http/order/index";
import {sendMailCode,exportRecord} from "@http/overview/index";
import {formatDate,filterParams,sourceType} from "@/utils/filter";
import NoTrace from '@/utils/noTrace';
import qs from 'qs'
var interval = null;
export default {
    name: "orderList",
    data() {
        var email=(rule, value, callback) => {
            let reg = new RegExp(
                "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+\\.){1,63}[a-z0-9]+$"
                );
            if (!reg.test(value)) {
                callback(new Error("邮箱格式不正确"));
            }
            callback();
        };
        return {
            isShow:false,
            isShow2:false,
            isShow3:false,
            activeName: "first",
            tabList:[
                {
                    name:'first',
                    val:1
                },
                {
                    name:'second',
                    val:2
                },
                {
                    name:'third',
                    val:3
                },
                {
                    name:'four',
                    val:4
                },
                {
                    name:'five',
                    val:5
                },
                {
                    name:'six',
                    val:6
                },
            ],
            dataVal1:'',
            dataVal2:'',
            dataVal3:'',
            dataVal4:'',
            dataVal5:'',
            dataVal6:'',
            pageSizeNum1:10,
            pageSizeNum2:10,
            pageSizeNum3:10,
            pageSizeNum4:10,
            pageSizeNum5:10,
            pageSizeNum6:10,
            //已支付查询条件
            searchParam1: {
                page: 1,
                size: 10,
                status:1,
                orderId:'',
                startPaymentAt:'',
                endPaymentAt:'',
            },
            tableData1:[],
            header1: [
                { prop: "id", label: "订单号" ,minWidth:100},
                {
                    prop: "paymentAt",
                    minWidth:110,
                    label: "支付时间",
                    formatter: (row) => {
                        return formatDate(row.paymentAt);
                    },
                },
                {
                    minWidth:100,
                    prop: "suiteName",
                    label: "服务包名称",
                },
                {
                    minWidth:95,
                    prop: "tsCount",
                    label: "时间戳总数",
                    formatter: (row) => {
                        return row.tsCount + "个";
                    },
                },
                {
                    minWidth:95,
                    prop: "presentedTsCount",
                    label: "赠送个数",
                    formatter: (row) => {
                        return row.presentedTsCount + "个";
                    },
                },
                {
                    minWidth:70,
                    prop: "suiteValidityPeriod",
                    label: "有效期",
                    formatter: (row) => {
                        if(row.suiteValidityPeriod==0){
                            return '永久有效'
                        }else{
                            return row.suiteValidityPeriod+'天'
                        }
                    },
                },
                {
                    minWidth:80,
                    prop: "amount",
                    label: "原价",
                    formatter: (row) => {
                    return row.amount+'元';
                    },
                },
                {
                    minWidth:80,
                    prop: "dueAmount",
                    label: "应付金额",
                    formatter: (row) => {
                    return row.dueAmount+'元';
                    },
                },
                {
                    minWidth:80,
                    prop: "discountAmount",
                    label: "优惠金额",
                    formatter: (row) => {
                    return row.discountAmount+'元' || '--';
                    },
                },
                {
                    minWidth:80,
                    prop: "payAmount",
                    label: "实付金额",
                    formatter: (row) => {
                    return row.payAmount+'元';
                    },
                },
                {
                    minWidth:120,
                    prop: "couponName",
                    label: "使用优惠券",
                    formatter: (row) => {
                        return row.couponName || '--';
                    },
                },
                {
                    width:80,
                    prop: "payType",
                    label: "支付方式",
                    formatter: (row) => {
                        switch (row.payType) {
                            case 0:
                                return "未支付";
                                break;
                            case 1:
                                return "支付宝";
                                break;
                            case 2:
                                return "微信";
                                break;
                            case 3:
                                return "银联";
                                break;
                            case 4:
                                return "赠送";
                                break;
                            case 5:
                                return "兑换码";
                                break;
                            case 9:
                                return "--";
                                break;
                            case 127:
                                return "--";
                                break;
                        }
                    },
                },
                {
                    width:80,
                    prop: "sourceTypeName",
                    label: "订单来源",
                },
                {
                    minWidth:40,
                    slot: 'operate'
                }
            ],
            total1:10,
            // 待支付查询条件
            searchParam2: {
                page: 1,
                size: 10,
                status:0,
                orderId:'',
                startCreatedAt:'',
                endCreatedAt:'',
            },
            tableData2:[],
            header2: [
                { prop: "id", label: "订单号" ,minWidth:100},
                {
                    prop: "createdAt",
                    label: "订单创建时间",
                    minWidth:110,
                    formatter: (row) => {
                        return formatDate(row.createdAt);
                    },
                },
                {
                    minWidth:100,
                    prop: "suiteName",
                    label: "服务包名称",
                },
                {
                    minWidth:95,
                    prop: "tsCount",
                    label: "时间戳总数",
                    formatter: (row) => {
                        return row.tsCount + "个";
                    },
                },
                {
                    minWidth:95,
                    prop: "presentedTsCount",
                    label: "赠送个数",
                    formatter: (row) => {
                        return row.presentedTsCount + "个";
                    },
                },
                {
                    minWidth:70,
                    prop: "suiteValidityPeriod",
                    label: "有效期",
                    formatter: (row) => {
                        if(row.suiteValidityPeriod==0){
                            return '永久有效'
                        }else{
                            return row.suiteValidityPeriod+'天'
                        }
                    },
                },
                {
                    minWidth:80,
                    prop: "amount",
                    label: "原价",
                    formatter: (row) => {
                      return row.amount+'元';
                    },
                },
                {
                    minWidth:80,
                    prop: "dueAmount",
                    label: "应付金额",
                    formatter: (row) => {
                    return row.dueAmount+'元';
                    },
                },
                {
                    minWidth:80,
                    prop: "discountAmount",
                    label: "优惠金额",
                    formatter: (row) => {
                    return row.discountAmount+'元' || '--';
                    },
                },
                {
                    minWidth:80,
                    prop: "payAmount",
                    label: "实付金额",
                    formatter: (row) => {
                      return row.payAmount+'元';
                    },
                },
                {
                    minWidth:120,
                    prop: "couponName",
                    label: "使用优惠券",
                    formatter: (row) => {
                        return row.couponName || '--';
                    },
                },
                // {
                //     width:80,
                //     prop: "buyType",
                //     label: "购买方式",
                //     formatter: (row) => {
                //         return row.buyType === 0 ? "前台购买" : "线下充值";
                //     },
                // },
                {
                    width:80,
                    prop: "payType",
                    label: "支付方式",
                    formatter: (row) => {
                        switch (row.payType) {
                            case 0:
                                return "未支付";
                                break;
                            case 1:
                                return "支付宝";
                                break;
                            case 2:
                                return "微信";
                                break;
                            case 3:
                                return "银联";
                                break;
                            case 4:
                                return "赠送";
                                break;
                            case 5:
                                return "兑换码";
                                break;
                            case 9:
                                return "--";
                                break;
                            case 127:
                                return "--";
                                break;
                        }
                    },
                },
                {
                    width:80,
                    prop: "sourceTypeName",
                    label: "订单来源",
                },
                {
                    slot: 'operate'
                }
            ],
            total2:10,
            //已取消
            searchParam3: {
                page: 1,
                size: 10,
                status:2,
                orderId:'',
                startCreatedAt:'',
                endCreatedAt:'',
            },
            tableData3:[],
            header3: [
                { prop: "id", label: "订单号" ,minWidth:120},
                {
                    minWidth:120,
                    prop: "createdAt",
                    label: "订单创建时间",
                    formatter: (row) => {
                        return formatDate(row.createdAt);
                    },
                },
                {
                    minWidth:100,
                    prop: "suiteName",
                    label: "服务包名称",
                },
                {
                    minWidth:95,
                    prop: "tsCount",
                    label: "时间戳总数",
                    formatter: (row) => {
                        return row.tsCount + "个";
                    },
                },
                {
                    minWidth:95,
                    prop: "presentedTsCount",
                    label: "赠送个数",
                    formatter: (row) => {
                        return row.presentedTsCount + "个";
                    },
                },
                {
                    minWidth:70,
                    prop: "suiteValidityPeriod",
                    label: "有效期",
                    formatter: (row) => {
                        if(row.suiteValidityPeriod==0){
                            return '永久有效'
                        }else{
                            return row.suiteValidityPeriod+'天'
                        }
                    },
                },
              {
                minWidth:80,
                prop: "amount",
                label: "原价",
                formatter: (row) => {
                  return row.amount+'元';
                },
              },
              {
                    minWidth:80,
                    prop: "dueAmount",
                    label: "应付金额",
                    formatter: (row) => {
                    return row.dueAmount+'元';
                    },
                },
                {
                    minWidth:80,
                    prop: "discountAmount",
                    label: "优惠金额",
                    formatter: (row) => {
                    return row.discountAmount+'元' || '--';
                    },
                },
                {
                    minWidth:80,
                    prop: "payAmount",
                    label: "实付金额",
                    formatter: (row) => {
                      return row.payAmount+'元';
                    },
                },
                {
                    minWidth:120,
                    prop: "couponName",
                    label: "使用优惠券",
                    formatter: (row) => {
                        return row.couponName || '--';
                    },
                },
                {
                    width:80,
                    prop: "sourceTypeName",
                    label: "订单来源",
                },
            ],
            total3:10,
            //已退款
            searchParam4: {
                page: 1,
                size: 10,
                status:3,
                orderId:'',
                startCreatedAt:'',
                endCreatedAt:'',
            },
            tableData4:[],
            header4: [
                { prop: "id", label: "订单号" ,minWidth:120},
                {
                    minWidth:120,
                    prop: "createdAt",
                    label: "订单创建时间",
                    formatter: (row) => {
                        return formatDate(row.createdAt);
                    },
                },
                {
                    minWidth:120,
                    prop: "updatedAt",
                    label: "退款时间",
                    formatter: (row) => {
                        return formatDate(row.updatedAt);
                    },
                },

                {
                    minWidth:100,
                    prop: "suiteName",
                    label: "服务包名称",
                },
                {
                    minWidth:95,
                    prop: "tsCount",
                    label: "时间戳总数",
                    formatter: (row) => {
                        return row.tsCount + "个";
                    },
                },
                {
                    minWidth:95,
                    prop: "presentedTsCount",
                    label: "赠送个数",
                    formatter: (row) => {
                        return row.presentedTsCount + "个";
                    },
                },
                {
                    minWidth:70,
                    prop: "suiteValidityPeriod",
                    label: "有效期",
                    formatter: (row) => {
                        if(row.suiteValidityPeriod==0){
                            return '永久有效'
                        }else{
                            return row.suiteValidityPeriod+'天'
                        }
                    },
                },
                {
                  minWidth:80,
                  prop: "payAmount",
                  label: "实付金额",
                  formatter: (row) => {
                    return row.payAmount+'元';
                  },
                },
                {
                    minWidth:80,
                    prop: "refundAmount",
                    label: "退款金额",
                    formatter: (row) => {
                    return row.refundAmount+'元';
                    },
                },
                {
                    minWidth:80,
                    prop: "remainTsCount",
                    label: "退还个数",
                    formatter: (row) => {
                    return row.remainTsCount+'个';
                    },
                },
                {
                    width:80,
                    prop: "sourceTypeName",
                    label: "订单来源",
                },
                {
                    width:80,
                    prop: "partnerName",
                    label: "合作方",
                },
            ],
            total4:10,
            //已转入
            searchParam5: {
                page: 1,
                size: 10,
                payType:8,
                orderId:'',
                startPaymentAt:'',
                endPaymentAt:'',
            },
            tableData5:[],
            header5: [
                { prop: "id", label: "订单号" ,minWidth:100},
                {
                    prop: "createdAt",
                    label: "订单创建时间",
                    minWidth:110,
                    formatter: (row) => {
                        return formatDate(row.createdAt);
                    },
                },
                {
                    minWidth:100,
                    prop: "suiteName",
                    label: "服务包名称",
                },
                {
                    minWidth:95,
                    prop: "tsCount",
                    label: "时间戳总数",
                    formatter: (row) => {
                        return row.tsCount + "个";
                    },
                },
                {
                    minWidth:95,
                    prop: "presentedTsCount",
                    label: "赠送个数",
                    formatter: (row) => {
                        return row.presentedTsCount + "个";
                    },
                },
                {
                    minWidth:70,
                    prop: "suiteValidityPeriod",
                    label: "有效期",
                    formatter: (row) => {
                        if(row.suiteValidityPeriod==0){
                            return '永久有效'
                        }else{
                            return row.suiteValidityPeriod+'天'
                        }
                    },
                },
              {
                minWidth:80,
                prop: "payAmount",
                label: "实付金额",
                formatter: (row) => {
                  return row.payAmount+'元';
                },
              },
              {
                minWidth:100,
                prop: "outflowAccount",
                label: "转出账号",
              },
              {
                minWidth:100,
                prop: "outflowOrderId",
                label: "转出订单号",
              },
                {
                    width:80,
                    prop: "payType",
                    label: "支付方式",
                    formatter: (row) => {
                        switch (row.payType) {
                            case 0:
                                return "未支付";
                                break;
                            case 1:
                                return "支付宝";
                                break;
                            case 2:
                                return "微信";
                                break;
                            case 3:
                                return "银联";
                                break;
                            case 4:
                                return "赠送";
                                break;
                            case 5:
                                return "兑换码";
                                break;
                            case 8:
                                return "转入";
                                break;
                            case 9:
                                return "--";
                                break;
                            case 127:
                                return "--";
                                break;
                        }
                    },
                },
            ],
            total5:10,
            //预充值
            searchParam6: {
                page: 1,
                size: 10,
                payType:6,
                orderId:'',
                startPaymentAt:'',
                endPaymentAt:'',
            },
            tableData6:[],
            header6: [
                { prop: "id", label: "订单号" ,minWidth:100},
                {
                    prop: "createdAt",
                    label: "订单创建时间",
                    minWidth:110,
                    formatter: (row) => {
                        return formatDate(row.createdAt);
                    },
                },
                {
                    minWidth:100,
                    prop: "suiteName",
                    label: "服务包名称",
                },
                {
                    minWidth:95,
                    prop: "tsCount",
                    label: "时间戳总数",
                    formatter: (row) => {
                        return row.tsCount + "个";
                    },
                },
                {
                    minWidth:95,
                    prop: "presentedTsCount",
                    label: "赠送个数",
                    formatter: (row) => {
                        return row.presentedTsCount + "个";
                    },
                },
                {
                    minWidth:70,
                    prop: "suiteValidityPeriod",
                    label: "有效期",
                    formatter: (row) => {
                        if(row.suiteValidityPeriod==0){
                            return '永久有效'
                        }else{
                            return row.suiteValidityPeriod+'天'
                        }
                    },
                },
                {
                    minWidth:80,
                    prop: "amount",
                    label: "原价",
                    formatter: (row) => {
                    return row.amount+'元';
                    },
                },
                {
                    minWidth:80,
                    prop: "payAmount",
                    label: "实付金额",
                    formatter: (row) => {
                        return row.payAmount+'元';
                    },
                },
                {
                    minWidth:80,
                    prop: "prepayAmount",
                    label: "预付金额",
                    formatter: (row) => {
                        return row.prepayAmount+'元';
                    },
                },
                {
                    width:80,
                    prop: "buyType",
                    label: "购买方式",
                    formatter: (row) => {
                        switch (row.buyType) {
                            case 0:
                                return "前台购买";
                                break;
                            case 1:
                                return "线下充值";
                                break;
                            case 2:
                                return "赠送";
                                break;
                            case 3:
                                return "兑换码";
                                break;
                            case 127:
                                return "其它";
                                break;
                        }
                    }
                },
                {
                    width:80,
                    prop: "payType",
                    label: "支付方式",
                    formatter: (row) => {
                        switch (row.payType) {
                            case 0:
                                return "未支付";
                                break;
                            case 1:
                                return "支付宝";
                                break;
                            case 2:
                                return "微信";
                                break;
                            case 3:
                                return "银联";
                                break;
                            case 4:
                                return "赠送";
                                break;
                            case 5:
                                return "兑换码";
                                break;
                            case 6:
                                return "预充值";
                                break;
                            case 8:
                                return "转入";
                                break;
                            case 9:
                                return "--";
                                break;
                            case 127:
                                return "--";
                                break;
                        }
                    },
                },
                {
                    minWidth:80,
                    prop: "status",
                    label: "还款状态",
                    render: (h, data) => {
                        if (data.row.status==1) {
                                return (<span style="color:#4f9e48">已还清</span>);                                
                        }else{
                            return (<span style="color:#f70f0f">未还清</span>);
                        }
                    },
                },
            ],
            total6:10,
            
            exportDialog:false,
            yzmtext: "获取验证码",
            disabled:false,
            currentTime:60,
            exportForm: {
                email: '',
                yzm: '',
            },
            rules: {
                email:[
                    { required: true, message: '请输入邮箱', trigger: 'blur' },
                    { validator: email, trigger: "blur" }
                ],
                yzm: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                    
                ],
            },
            nvc:'',
        };
    },
    components: {
        ExTable,
    },
    async created(){
        userOrderRefund().then((res2)=>{
            res2?.status==1?this.isShow=true : this.isShow=false;
        });
        userOrderInflow().then((res3)=>{
            res3?.status==1?this.isShow2=true : this.isShow2=false;
        });
        userOrderPreRecharge().then((res4)=>{
            res4?.status==1?this.isShow3=true : this.isShow3=false;
        });
        let tabVal=this.$route.query.tabVal || '';
        //有参数传过来先判断参数是否合法范围内1-6
        if((tabVal==4 && this.isShow) || (tabVal==5 && this.isShow2) || (tabVal==6 && this.isShow3) || [1,2,3].includes(tabVal*1)){
            //切换参数对应tab
            let tabActiveItem = this.tabList.find(obj => obj.val == tabVal);
            this.activeName=tabActiveItem.name;
            let res = await this.getTableData(filterParams(this[`searchParam${tabVal}`]));
            this[`tableData${tabVal}`] = res.data;
            this[`total${tabVal}`] = res.total;
        }else{//原逻辑
            this.activeName='first';
            let res=await this.getTableData(filterParams(this.searchParam1));
            this.tableData1 =res.data;
            this.total1=res.total;
        }
    },
    computed: {
        channelCodeValue(){
            return this.$store.state.config.channelCodeValue;
        },
    },
    mounted() {
        NoTrace.init('captcha-element', 'captcha-button')
    },
    beforeDestroy() {
        NoTrace.reset()
    },
    methods: {
        goPayOredr(row){
            let sourceType=this.$getlocalStorage("queryData")?.sourceType || this.$getlocalStorage("queryData")?.clientId || 975260;
            zhuge.track('用户中心_待支付订单_继续支付', {
                '页面名称': '订单列表',
                '付费方式': row.payType === 1 ? '支付宝': row.payType === 2 ? '微信' : row.payType === 3 ? '银行卡' : '',
                // '套餐名称':  '',
                '服务包名称': row.suiteName,
                '时间戳个数': row.tsCount,
                '服务包金额': row.dueAmount,
            },()=>{
                window.location.href=`/api/order/continuePay?orderId=${row.id}&sourceType=${sourceType}`
            })
        },
        async cancelOrder(row){
            let that=this;
            this.$confirm('确认取消该订单吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '关闭',
                type: 'warning'
            }).then(() => {
                orderToCancel({orderId:row.id}).then(async (res)=>{
                    zhuge.track('用户中心_待支付订单-取消订单', {
                        '页面名称': '订单列表'
                    })
                    this.$TsaOrderCancelSuccessDialog.show({
                        type: 2
                    })
                    that.searchParam2.page=1;
                    let table2=await that.getTableData(filterParams(this.searchParam2));
                    that.tableData2=table2.data;
                    that.total2=table2.total;
                }).catch(() => {
                    that.$msg("该订单取消失败，请稍后再试");
                });
            })
        },
        async getTableData(data) {
            let res = await orderData(data);
            // console.log(res)
            return res
        },
        async selectTable(name){
            let res;
            var re = /^[0-9]+.?[0-9]*/;//判断字符串是否为数字//判断正整数/[1−9]+[0−9]∗]∗/ 
            if(name=='first'){
                if(this.searchParam1.orderId &&!re.test(this.searchParam1.orderId)){
                    this.$msg("订单号输入内容格式不正确，请仔细核对");
                    return false;
                }
                this.searchParam1.page=1;
                res=await this.getTableData(filterParams(this.searchParam1));
                this.tableData1=res.data;
                this.total1=res.total;
            }else if(name=='second'){
                if(this.searchParam2.orderId && !re.test(this.searchParam2.orderId)){
                    this.$msg("订单号输入内容格式不正确，请仔细核对");
                    return false;
                }
                this.searchParam2.page=1;
                res=await this.getTableData(filterParams(this.searchParam2));
                this.tableData2=res.data;
                this.total2=res.total;
            }else if(name=='third'){
                if(this.searchParam3.orderId && !re.test(this.searchParam3.orderId)){
                    this.$msg("订单号输入内容格式不正确，请仔细核对");
                    return false;
                }
                this.searchParam3.page=1;
                res=await this.getTableData(filterParams(this.searchParam3));
                this.tableData3=res.data;
                this.total3=res.total;
            }else if(name=='four'){
                if(this.searchParam4.orderId && !re.test(this.searchParam4.orderId)){
                    this.$msg("订单号输入内容格式不正确，请仔细核对");
                    return false;
                }
                this.searchParam4.page=1;
                res=await this.getTableData(filterParams(this.searchParam4));
                this.tableData4=res.data;
                this.total4=res.total;
            }else if(name=='five'){
                if(this.searchParam5.orderId && !re.test(this.searchParam5.orderId)){
                    this.$msg("订单号输入内容格式不正确，请仔细核对");
                    return false;
                }
                this.searchParam5.page=1;
                res=await this.getTableData(filterParams(this.searchParam5));
                this.tableData5=res.data;
                this.total5=res.total;
            }else{
                if(this.searchParam6.orderId && !re.test(this.searchParam6.orderId)){
                    this.$msg("订单号输入内容格式不正确，请仔细核对");
                    return false;
                }
                this.searchParam6.page=1;
                res=await this.getTableData(filterParams(this.searchParam6));
                this.tableData6=res.data;
                this.total6=res.total;
            }
        },
        async handleClick(tab) {
            let res;
            if(tab.name=='first'){
                this.$nextTick(() => { this.$refs.table1.$refs.table.doLayout() })
                if(!(this.tableData1.length>0)){
                    res=await this.getTableData(filterParams(this.searchParam1));
                    this.tableData1=res.data;
                    this.total1=res.total;
                }
            }else if(tab.name=='second'){
                this.$nextTick(() => { this.$refs.table2.$refs.table.doLayout() })
                zhuge.track('用户中心_查看待支付订单', {'渠道': this.channelCodeValue})
                if(!(this.tableData2.length>0)){
                    res=await this.getTableData(filterParams(this.searchParam2));
                    this.tableData2=res.data;
                    this.total2=res.total;
                }
            }else if(tab.name=='third'){
                this.$nextTick(() => { this.$refs.table3.$refs.table.doLayout() })
                zhuge.track('用户中心_查看已取消订单', {'渠道': this.channelCodeValue})
                if(!(this.tableData3.length>0)){
                    res=await this.getTableData(filterParams(this.searchParam3));
                    this.tableData3=res.data;
                    this.total3=res.total;
                }
            }else if(tab.name=='four'){
                this.$nextTick(() => { this.$refs.table4.$refs.table.doLayout() })
                if(!(this.tableData4.length>0)){
                    res=await this.getTableData(filterParams(this.searchParam4));
                    this.tableData4=res.data;
                    this.total4=res.total;
                }
            }else if(tab.name=='five'){
                this.$nextTick(() => { this.$refs.table5.$refs.table.doLayout() })
                if(!(this.tableData5.length>0)){
                    res=await this.getTableData(filterParams(this.searchParam5));
                    this.tableData5=res.data;
                    this.total5=res.total;
                }
            }else{
                this.$nextTick(() => { this.$refs.table6.$refs.table.doLayout() })
                if(!(this.tableData6.length>0)){
                    res=await this.getTableData(filterParams(this.searchParam6));
                    this.tableData6=res.data;
                    this.total6=res.total;
                }
            }
        },
        datetime(e){
            if(this.activeName=='first'){
                if(e){
                    this.searchParam1.startPaymentAt=e[0];
                    this.searchParam1.endPaymentAt=e[1];
                }else{
                    this.searchParam1.startPaymentAt='';
                    this.searchParam1.endPaymentAt='';
                }

            }else if(this.activeName=='second'){
                if(e){
                    this.searchParam2.startCreatedAt=e[0];
                    this.searchParam2.endCreatedAt=e[1];
                }else{
                    this.searchParam2.startCreatedAt='';
                    this.searchParam2.endCreatedAt='';
                }
            }else if(this.activeName=='third'){
                if(e){
                    this.searchParam3.startCreatedAt=e[0];
                    this.searchParam3.endCreatedAt=e[1];
                }else{
                    this.searchParam3.startCreatedAt='';
                    this.searchParam3.endCreatedAt='';
                }
            }else if(this.activeName=='four'){
                if(e){
                    this.searchParam4.startCreatedAt=e[0];
                    this.searchParam4.endCreatedAt=e[1];
                }else{
                    this.searchParam4.startCreatedAt='';
                    this.searchParam4.endCreatedAt='';
                }
            }else if(this.activeName=='five'){
                if(e){
                    this.searchParam5.startCreatedAt=e[0];
                    this.searchParam5.endCreatedAt=e[1];
                }else{
                    this.searchParam5.startCreatedAt='';
                    this.searchParam5.endCreatedAt='';
                }
            }else{
                if(e){
                    this.searchParam6.startCreatedAt=e[0];
                    this.searchParam6.endCreatedAt=e[1];
                }else{
                    this.searchParam6.startCreatedAt='';
                    this.searchParam6.endCreatedAt='';
                }
            }
        },
        async clickPage(page,num){
            let res;
            if(num==1){
                this.searchParam1.page=page;
                res=await this.getTableData(filterParams(this.searchParam1));
                this.tableData1 =res.data;
                this.total1=res.total;
            }else if(num==2){
                this.searchParam2.page=page;
                res=await this.getTableData(filterParams(this.searchParam2));
                this.tableData2 =res.data;
                this.total2=res.total;
            }else if(num==3){
                this.searchParam3.page=page;
                res=await this.getTableData(filterParams(this.searchParam3));
                this.tableData3 =res.data;
                this.total3=res.total;
            }else if(num==4){
                this.searchParam4.page=page;
                res=await this.getTableData(filterParams(this.searchParam4));
                this.tableData4 =res.data;
                this.total4=res.total;
            }else if(num==5){
                this.searchParam5.page=page;
                res=await this.getTableData(filterParams(this.searchParam5));
                this.tableData5 =res.data;
                this.total5=res.total;
            }else{
                this.searchParam6.page=page;
                res=await this.getTableData(filterParams(this.searchParam6));
                this.tableData6 =res.data;
                this.total6=res.total;
            }
        },
        async clickSize(size,num){
            let res;
            if(num==1){
                this.searchParam1.page=1;
                this.searchParam1.size=size;
                this.pageSizeNum1=size;
                res=await this.getTableData(filterParams(this.searchParam1));
                this.tableData1 =res.data;
                this.total1=res.total;
            }else if(num==2){
                this.searchParam2.page=1;
                this.searchParam2.size=size;
                this.pageSizeNum2=size;
                res=await this.getTableData(filterParams(this.searchParam2));
                this.tableData2 =res.data;
                this.total2=res.total;
            }else if(num==3){
                this.searchParam3.page=1;
                this.searchParam3.size=size;
                this.pageSizeNum3=size;
                res=await this.getTableData(filterParams(this.searchParam3));
                this.tableData3 =res.data;
                this.total3=res.total;
            }else if(num==4){
                this.searchParam4.page=1;
                this.searchParam4.size=size;
                this.pageSizeNum4=size;
                res=await this.getTableData(filterParams(this.searchParam4));
                this.tableData4 =res.data;
                this.total4=res.total;
            }else if(num==5){
                this.searchParam5.page=1;
                this.searchParam5.size=size;
                this.pageSizeNum5=size;
                res=await this.getTableData(filterParams(this.searchParam5));
                this.tableData5 =res.data;
                this.total5=res.total;
            }else{
                this.searchParam6.page=1;
                this.searchParam6.size=size;
                this.pageSizeNum6=size;
                res=await this.getTableData(filterParams(this.searchParam6));
                this.tableData6 =res.data;
                this.total6=res.total;
            }
        },

        async getVerificationCode() { 
            let reg = new RegExp(
                "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+\\.){1,63}[a-z0-9]+$"
                );
            if (!reg.test(this.exportForm.email)) {
                this.$refs.exportForm.validateField("email");
                return false;
            }
            this.getCode();
            this.disabled = true;
            var that = this;

            // 开始获取无痕验证码
            NoTrace.start((nvc) => {
                this.nvc = nvc
            }, this.executeFun, {
                email:that.exportForm.email,
                nvc: '',
                afsVersion: 2
            })
        },
        executeFun (params) {
            let that=this;
            return new Promise(async (resolve, reject) => {
                try {
                    let res = await sendMailCode(qs.stringify(params));
                    resolve(res)
                    if(res.code==200){
                        that.$msg("验证码已发送，请注意接收", "success");
                    }
                }catch (err) {
                    reject(err)
                    clearInterval(interval);
                    that.yzmtext = "重新获取";
                    that.disabled = false;
                    that.currentTime = 60;
                }
            })
        },
        getCode() {
            var that = this;
            var currentTime = that.currentTime;
            interval = setInterval(function () {
                currentTime--;
                that.yzmtext = "(" + currentTime + "s)重新获取";
                if (currentTime <= 0) {
                clearInterval(interval);
                that.yzmtext = "重新获取";
                that.currentTime = 60;
                that.disabled = false;
                }
            }, 1000);
        },
        submitDialogForm(formName) {
            let that=this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    exportRecord(qs.stringify({
                        email:that.exportForm.email,
                        code:that.exportForm.yzm,
                        orderTransactionLogType:'RECHARGE'
                    })).then((res)=>{
                        if(res.code==200){
                            that.$msg('提交成功', "success");
                            that.closeDia();
                        }
                    }).catch((err)=>{
                        console.log(err)
                    })
                }else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        closeDia(){
            this.exportDialog = false;
            clearInterval(interval);
            this.yzmtext = "重新获取";
            this.currentTime = 60;
            this.disabled = false;
            this.exportForm.yzm='';
        },
        goBuy(){
            zhuge.track('用户中心_再次购买', {'渠道': this.channelCodeValue},()=> {
                this.$router.push({path:'/userAccount/buy'})
            })
        }
    },
};
</script>

<style lang="less">
.exportDialog {
    .el-dialog__header{
        background: #EEEEEE;
    }
    .el-dialog__body{
        padding-bottom:0
    }
    p{
        box-sizing: border-box;
        width: 100%;
        padding:20px;
        background: #FFF9E1;
        color:#F17D44;
        border-radius: 10px;
    }
}
.exportForm{
    padding:20px;
    .yzm-item {
        .el-form-item__content{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            .el-input{
                width:270px;
            }
            .getyzm{
                width: 120px;
                height: 28px;
                text-align: center;
                line-height: 28px;
                background: #fff;
                color: #3f7df7;
                cursor: pointer;
                border: 1px solid #3f7df7;
                font-size: 14px;
                &:hover{
                    background: #3f7df7;
                    color: #fff;
                }
            }
            .getyzm[disabled] {
                color: #fff;
                background: #bcbcbc;
                pointer-events: none;
                cursor: inherit;
                border-color: #bcbcbc;
            }
        }
        .el-form-item__content::after, .el-form-item__content::before{
            display: none;
        }
    }
}
.btn-group {
    display: flex;
    justify-content: center;
    .btn {
        cursor: pointer;
        font-size: 14px;
        color: #005CE6;
        &:first-child {
            margin-right: 20px;
        }
        &:last-child {
            margin-right: 0;
        }
    }
}
.tableBox {
    .el-table__fixed-right {
        &::before {
            display: none;
        }
    }
}
</style>
